import React from "react";
import PropTypes from "prop-types";
import PhoneInterview from "./PhoneInterview";
import FirstInterview from "./FirstInterview";
import SecondInterview from "./SecondInterview";
import Competencies from "./Competencies";
import RejectCandidate from "./RejectCandidate";
import MakeOffer from "./MakeOffer";

const EmployerKanbanModalContent = ({
  cardUpdateNewColumn,
  closeActionModalAfterReset,
  closeActionModalAfterSubmit,
  fetchKanbanData,
  cardData,
}) => {
  let content;

  switch (cardUpdateNewColumn) {
    case "phone-interview":
      content = (
        <PhoneInterview
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
      break;
    case "first-interview":
      content = (
        <FirstInterview
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
      break;
    case "second-interview":
      content = (
        <SecondInterview
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
      break;
    case "competencies":
      content = (
        <Competencies
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
      break;
    case "make-offer":
      content = (
        <MakeOffer
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
      break;
    default:
      content = (
        <RejectCandidate
          closeActionModalAfterReset={closeActionModalAfterReset}
          closeActionModalAfterSubmit={closeActionModalAfterSubmit}
          cardData={cardData}
          fetchKanbanData={fetchKanbanData}
        />
      );
  }

  return content;
};

EmployerKanbanModalContent.propTypes = {
  cardUpdateNewColumn: PropTypes.string.isRequired,
  closeActionModalAfterReset: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({}).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
};

export default EmployerKanbanModalContent;
